<template>
  <div v-if="isPresent(scheduledCancellation)" class="mt-6 rounded-xl bg-gray-50 p-5">
    <h2 class="text-lg font-semibold mb-4">Résiliation programmée</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
      <div class="space-y-2">
        <StackedField label="Date" :value="scheduledCancellation.date" />
        <StackedField
          label="Résilié par"
          :value="
            scheduledCancellation.initiatedBy
              ? $t('Cancellation initiated by.' + scheduledCancellation.initiatedBy)
              : ''
          "
        />
      </div>
      <div class="space-y-2 mt-1 md:mt-0">
        <StackedField
          label="Raison"
          :value="scheduledCancellation.reason ? $t('Plan cancellation reasons.' + scheduledCancellation.reason) : ''"
        />
        <StackedField label="Expérience" :value="scheduledCancellation.feedbackExperience" />
        <StackedField label="Message" :value="scheduledCancellation.feedbackMessage" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, isPresent } from "@estaly/ui";

export default {
  components: {
    StackedField,
  },

  props: ["scheduledCancellation"],

  methods: {
    isPresent,
  },
};
</script>
